import ConsiderationList from './ConsiderationList'

export default ConsiderationList
